/*
 * @Author: shanshan.hu
 * @FilePath: \cbest-welfare-erp-h5\src\views\Order\components\Selector.js
 */
import { useEffect } from 'react'
import { Select } from 'antd'
import service from '../../../@services'
import { connect } from 'react-redux'
/**
 *
 * @param {String} tag 选择器name
 * @param {String} mode 是否可多选（默认多选，不多选需传值为空字符串）
 * @param {Function} onChange 改变方法
 * @param {Object} style 选择框样式
 * @param {String} keyValue 所需字段名 默认code
 * @param {Object} order 下拉框数据（store)
 * @returns 下拉列表组件
 */
const Selector = ({
  style = {},
  onChange,
  order,
  tag,
  mode = 'multiple',
  keyValue = 'code',
  filter = ''
}) => {
  useEffect(() => {
    if (tag && order && !order[tag]) {
      if (tag == 'payTypes') {
        service.order.getPayTypes()
      } else {
         service.order.getDropDownList(tag)
      }
    }
  }, [order[tag]])
  const _onChange = e => {
    onChange && onChange(e)
  }
  return (
    <Select
      style={{ textAlign: 'left', width: '200px', ...style }}
      onChange={_onChange}
      placeholder='全部'
      optionFilterProp='children'
      showSearch
      allowClear
      mode={mode}>
      {!!(order && order[tag]) &&
        order[tag]
          .filter(item => !filter || filter != item.code)
          .map(item => (
            <Select.Option key={item.name} value={item[keyValue]}>
              {item.name}
            </Select.Option>
          ))}
    </Select>
  )
}
export default connect(state => ({ order: state.order }))(Selector)
